import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import RequirePermission from "components/util-components/RequirePermission";
import { PERMISSIONS } from "functions/permissions";
import { usePermissions } from "../../data/hooks/usePermissions";
import { getDefaultPath } from "configs/NavigationConfig";
import Orders from "./orders";
import Products from "./products";
import Reports from "./reports";
import Customers from "./customers";
import Discounts from "./discounts";
import Categories from "./categories";
import Admin from "./admin";
import Dealers from "./dealers";
import PurchaseOrders from "./purchase-orders";
import Shipments from "./shipments";
import Documentation from "./documentation";

// Startpagina = eerste menu-item dat deze gebruiker mag zien (voor een admin
// blijft dat de rapportage/orders zoals voorheen, voor een verkoper de klanten).
const DefaultRedirect = () => {
  const { can, loading } = usePermissions();
  if (loading) return <Loading cover="content" />;
  return <Navigate to={getDefaultPath(can)} replace />;
};

// Elke routegroep achter dezelfde permissie als het bijbehorende menu-item
// (configs/NavigationConfig.js). Fijnere verdeling binnen een groep — Exact
// onder orders, wachtend/doelgroepen onder klanten, beheer-subpagina's —
// staat in de index.js van die groep.
export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Routes>
        <Route
          path={`/reports/*`}
          element={
            <RequirePermission permission={PERMISSIONS.REPORTS_VIEW}>
              <Reports />
            </RequirePermission>
          }
        />
        <Route
          path={`/products/*`}
          element={
            <RequirePermission permission={PERMISSIONS.PRODUCTS_MANAGE}>
              <Products />
            </RequirePermission>
          }
        />
        <Route
          path={`/orders/*`}
          element={
            <RequirePermission permission={PERMISSIONS.ORDERS_VIEW}>
              <Orders />
            </RequirePermission>
          }
        />
        <Route
          path={`/customers/*`}
          element={
            <RequirePermission permission={PERMISSIONS.CUSTOMERS_VIEW}>
              <Customers />
            </RequirePermission>
          }
        />
        <Route
          path={`/discounts/*`}
          element={
            <RequirePermission permission={PERMISSIONS.DISCOUNTS_MANAGE}>
              <Discounts />
            </RequirePermission>
          }
        />
        <Route
          path={`/categories`}
          element={
            <RequirePermission permission={PERMISSIONS.CATEGORIES_MANAGE}>
              <Categories />
            </RequirePermission>
          }
        />
        <Route
          path={`/dealers`}
          element={
            <RequirePermission permission={PERMISSIONS.DEALERS_MANAGE}>
              <Dealers />
            </RequirePermission>
          }
        />
        <Route path={`/admin/*`} element={<Admin />} />
        <Route
          path={`/purchase-orders/*`}
          element={
            <RequirePermission permission={PERMISSIONS.PURCHASING_MANAGE}>
              <PurchaseOrders />
            </RequirePermission>
          }
        />
        <Route
          path={`/shipments/*`}
          element={
            <RequirePermission permission={PERMISSIONS.SHIPMENTS_MANAGE}>
              <Shipments />
            </RequirePermission>
          }
        />
        <Route
          path={`/documentation`}
          element={
            <RequirePermission permission={PERMISSIONS.ADMIN_DOCUMENTATION}>
              <Documentation />
            </RequirePermission>
          }
        />
        <Route path={``} element={<DefaultRedirect />} />
      </Routes>
    </Suspense>
  );
};

export default React.memo(AppViews);
